<script setup lang="ts">

import ColoredNumber from '@/components/Elements/Generic/ColoredNumber.vue'

/**
 * Props
 */
defineProps({
  amount: {
    type: Number,
    required: true
  },
  text: {
    type: String,
    required: true
  }
});

</script>

<template>
  <div class="p-1">{{ text }}</div>
  <div class="p-1 text-right"><ColoredNumber :amount="Number(amount)" :fractions="true" :shortFormat="false"></ColoredNumber></div>
</template>

<style scoped lang="scss">

</style>